import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A little bit of burn out? Perhaps",
  "description": "",
  "published": "2010-04-15T00:00:00.000Z",
  "redirect_from": ["/blog/a-little-bit-of-burn-out-perhaps/swizec/1304"],
  "categories": "life, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`This whole week has been one sluggish lazy blur.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://www.flickr.com/photos/27674701@N00/2597952748"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/04/2597952748_4ae4250c21_m.jpg",
              "alt": "IMG_0067a",
              "title": "IMG_0067a"
            }}></img></a></p>
        <p parentName="li">{`Image by `}<a parentName="p" {...{
            "href": "http://www.flickr.com/photos/27674701@N00/2597952748"
          }}>{`Archman8`}</a>{` via Flickr`}</p>
      </li>
    </ul>
    <p>{`Yes I know it's only Thursday.`}</p>
    <p>{`All week the earliest I ventured outside the apartment was at noon. And I just didn't do anything very productive at all for some reason. Whenever I did do some work it was at a slow leisurely pace. A few clicks here. Tap tap there. Point point test yonder.`}</p>
    <p>{`Like, for example, instead of working hard on building a testing framework for my machine learning frameworks last night I ... invited the girlfriend over, had a nice and comfortable dinner (unfortunately not a very tasty one) then watched a movie or somesuch and went to bed earlier than midnight.`}</p>
    <p>{`No, cuddling is not being productive.`}</p>
    <p>{`And today we watched television, TELEVISION, until something like 12 o'clock and went off into the great wide open to find new adventures.`}</p>
    <p>{`Yep, the whole week has been one big lazy yawn with a bit of running and exercise and a little productivity. Hell, it's already Thursday and I've only been productive 43 hours this week! Ew! If I didn't love it so much I'd almost be disgusted with myself.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://www.flickr.com/photos/31355686@N00/2715700690"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/04/2715700690_c7f92c51d2_m.jpg",
              "alt": "20080523 - computer - 1 - 157-5735 - stickers",
              "title": "20080523 - computer - 1 - 157-5735 - stickers"
            }}></img></a></p>
        <p parentName="li">{`Image by `}<a parentName="p" {...{
            "href": "http://www.flickr.com/photos/31355686@N00/2715700690"
          }}>{`Rev. Xanatos Satanicos Bombasticos (ClintJCL)`}</a>{` via Flickr`}</p>
      </li>
    </ul>
    <p>{`But truth be told, I absolutely needed a week just like this. I don't really deal well with proper vacations, get too bored. So this is perfect for me, have a week like normal people for once.`}</p>
    <p>{`It's nice. Guilty pleasures are always the bestest.`}</p>
    <p>{`Do people really survive their whole lives on only 9-ish hours of productivity every day `}<em parentName="p">{`excluding`}</em>{` weekends?`}</p>
    <p>{`I don't know if I can really believe that ... someone enlighten me.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/e75fbbbc-72f4-4135-9719-2426e4b36267/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=e75fbbbc-72f4-4135-9719-2426e4b36267",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      